















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Action, Mutation, Getter, namespace } from "vuex-class";
import { Auth } from "@/http/api/auth";
import { Weather } from "@/http/api/v2/weather";
import { HotelWeatherDto } from "@/http/dto/weather";
import moment from "moment";

const HotelModule = namespace("HotelModule");

@Component({
  components: {},
})
export default class HotelHeader extends Vue {
  @Prop({ default: "" }) value: any;

  @HotelModule.State("hotelInfo") hotelInfo: any;
  @HotelModule.Action("toHotelUrl") toHotelUrl: any;

  weather: HotelWeatherDto | null = null;
  weatherLoading = false;
  weatherTimer: number | null = null;

  rightTabs = [
    {
      key: "notification",
      name: "알림",
      off: "/assets/components/notice-off.svg",
      on: "/assets/components/notice-on.svg",
    },
    {
      key: "mention",
      name: "멘션",
      off: "/assets/components/mention-off.svg",
      on: "/assets/components/mention-on.svg",
    },
    {
      key: "bookmark",
      name: "북마크",
      off: "/assets/components/bookmark-off.svg",
      on: "/assets/components/bookmark-on.svg",
    },
    {
      key: "file",
      name: "파일",
      off: "/assets/components/file-off.svg",
      on: "/assets/components/file-on.svg",
    },
    {
      key: "team",
      name: "조직도",
      off: "/assets/components/group-off.svg",
      on: "/assets/components/group-on.svg",
    },
  ];

  get name() {
    return this.hotelInfo?.userName ?? "이름없음";
  }

  get team() {
    return this.hotelInfo?.team ?? (this.hotelInfo.userPermission === 3 ? "마스터" : "미소속");
  }

  get hotelObjectId() {
    return this.hotelInfo && this.hotelInfo.objectId;
  }

  get weatherLocationLabel() {
    if ((this.hotelInfo?.url || "").toLowerCase() === "thebesthotel") {
      return "강릉 강문동";
    }

    return this.weather?.locationName || "위치 확인 필요";
  }

  get observedAt() {
    return this.weather && this.weather.observationTime
      ? moment(this.weather.observationTime).format("HH:mm 기준")
      : "-";
  }

  get checkedAt() {
    return this.weather && this.weather.checkedTime
      ? moment(this.weather.checkedTime).format("HH:mm")
      : "-";
  }

  mounted() {
    this.loadWeather();
    this.weatherTimer = window.setInterval(() => this.loadWeather(), 10 * 60 * 1000);
  }

  beforeDestroy() {
    if (this.weatherTimer !== null) {
      window.clearInterval(this.weatherTimer);
    }
  }

  @Watch("hotelObjectId")
  hotelChanged(value: string) {
    if (value) {
      this.weather = null;
      this.loadWeather();
    }
  }

  async loadWeather(refresh = false) {
    if (!this.hotelObjectId || this.weatherLoading) return;
    this.weatherLoading = true;
    try {
      this.weather = await Weather.get(this.hotelObjectId, refresh);
    } catch {
      if (!this.weather) {
        this.weather = {
          available: false,
          message: "날씨 정보를 불러오지 못했습니다.",
          checkedTime: moment().format(),
          isStale: false,
          forecasts: [],
        };
      }
    } finally {
      this.weatherLoading = false;
    }
  }

  weatherIcon(condition?: string) {
    return ({
      clear: "☀️",
      cloudy: "🌤️",
      overcast: "☁️",
      rain: "🌧️",
      drizzle: "🌦️",
      "rain-snow": "🌨️",
      snow: "❄️",
    } as any)[condition || ""] || "🌡️";
  }

  temperature(value?: number) {
    return value == null ? "-" : `${Math.round(value)}℃`;
  }

  valueOrDash(value: number | undefined, unit: string) {
    return value == null ? "-" : `${Math.round(value * 10) / 10}${unit}`;
  }

  hour(value: string) {
    return moment(value).format("HH시");
  }

  change(item: any) {
    this.$emit("change", item.key);
  }

  async logout() {
    try {
      await Auth.logout();
    } finally {
      this.toHotelUrl({});
    }
  }
}
